import { useScrollReveal } from '@/hooks/useScrollReveal';

const benefits = [
  {
    icon: 'ri-mouse-line',
    title: 'Fácil de usar',
    description: 'Interfaz intuitiva diseñada para que cualquier miembro de tu equipo pueda operarla sin capacitación extensa.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Soporte local',
    description: 'Atención personalizada en español, entendemos la realidad de las cooperativas bolivianas.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Adaptado a Bolivia',
    description: 'Tarifas en bolivianos, nomenclatura local, y flujos de trabajo alineados a la normativa boliviana.',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Lecturación móvil',
    description: 'Los lecturadores reportan desde el campo con fotos del medidor y ubicación GPS, directo al sistema.',
  },
  {
    icon: 'ri-qr-code-line',
    title: 'Recibos con QR',
    description: 'Cada recibo incluye un código QR verificable. Tus afiliados pueden comprobar autenticidad al instante.',
  },
  {
    icon: 'ri-global-line',
    title: 'Portal para afiliados',
    description: 'Tus usuarios consultan su historial de consumo, pagos y deuda en cualquier momento, desde cualquier dispositivo.',
  },
];

export default function Benefits() {
  const { ref: sectionRef, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="beneficios" className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div ref={sectionRef} className="max-w-6xl mx-auto">
          {/* Header */}
          <div className={`text-center mb-14 md:mb-18 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-sm font-semibold mb-4">
              Ventajas competitivas
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary-900">
              Beneficios clave
            </h2>
            <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
              Acualys-Bo está pensado para resolver los problemas reales que enfrentan las cooperativas de agua todos los días.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {benefits.map((b, i) => (
              <div
                key={b.title}
                className={`group relative bg-background-50 border border-background-200 rounded-xl p-6 md:p-7 transition-all duration-500 hover:border-accent-300 hover:shadow-lg hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${(i + 1) * 120}ms` }}
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-lg bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-accent-50 transition-colors">
                  <i className={`${b.icon} text-xl text-primary-600 group-hover:text-accent-600 transition-colors`} />
                </div>

                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {b.title}
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {b.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}